import {IconButton, Modal} from '@yandex-delivery/blocks'
import {Image} from '@yandex-delivery/blocks/image'
import type {SidePanelProps} from '@yandex-delivery/blocks/modal/SidePanel'
import clsx from 'clsx'
import React, {memo} from 'react'

import {tagToUrl} from '../../lib/tagToUrl'
import {Body} from './components/Body'
import {FixedButton} from './components/FixedButton'
import {Header} from './components/Header'
import * as classes from './Drawer.classes'

export type DrawerProps = Pick<SidePanelProps, 'children' | 'onClose' | 'opened' | 'title'> & {
  anchor?: SidePanelProps['anchor']
  fullScreen?: boolean
}

const CROSS_ICON = 'delivery_cross_stroke'

const DrawerComponent = memo(
  ({anchor = 'bottom', children, fullScreen, onClose, opened, title}: DrawerProps): React.ReactElement => (
    <Modal.SidePanel
      anchor={anchor}
      className={clsx(classes.mobileDrawer, {[classes.fullScreen]: fullScreen})}
      onClose={onClose}
      opened={opened}
      preventScroll={false}
    >
      {!fullScreen && (
        <IconButton
          className={clsx(classes.floatingButton, classes.right)}
          onPress={onClose}
          shape="circle"
          variant="floating"
        >
          <Image src={tagToUrl(CROSS_ICON)} width={24} />
        </IconButton>
      )}

      {title && <Header onClose={fullScreen ? onClose : void 0} title={title} />}

      {children}
    </Modal.SidePanel>
  ),
)

export const Drawer = Object.assign(DrawerComponent, {Body, FixedButton})
